<div class="row">
  <div class="col-md-8">
    <div class="site-map">
      <h2>{{ siteMapMessages.sitemap | translate }}</h2>
      <div class="hierarchy">
        <ul>
          <li><a [routerLink]="'/accueil'">{{ siteMapMessages.home | translate }}</a></li>
          <li><a [routerLink]="'/avisdepublicite'">{{ siteMapMessages.avisPub | translate }}</a></li>
          <li class="title">{{ siteMapMessages.knowUs | translate }}</li>
          <ul>
            <li><a href="https://chorus-pro.gouv.fr/cpp/nousContacter">{{ siteMapMessages.contact | translate }}</a>
            </li>
          </ul>
          <li class="title">{{ siteMapMessages.ourEngagement | translate }}</li>
          <ul>
            <li><a
              href="https://aife.economie.gouv.fr/referentiel/engagement-et-qualite/">{{ siteMapMessages.commitmentQuality | translate }}</a>
            </li>
            <li><a
              href="https://esignature.chorus-pro.gouv.fr/accessibilite">{{ siteMapMessages.accessibility | translate }}</a>
            </li>
            <li><a
              href="https://aife.economie.gouv.fr/referentiel/protection-des-donnees-a-caractere-personnel/">{{ siteMapMessages.personalData | translate }}</a>
            </li>
            <li><a [routerLink]="'/mention-legal'">{{ siteMapMessages.legalsNotices | translate }}</a></li>
          </ul>
        </ul>
      </div>
    </div>
  </div>
</div>
